export default __webpack_public_path__ + "static/media/gallery_05.f6bb7a02.jpg";